__turbopack_context__.v({
  "applied": "du2YyW_applied",
  "badge": "du2YyW_badge",
  "body": "du2YyW_body",
  "card": "du2YyW_card",
  "cta": "du2YyW_cta",
  "entrance": "du2YyW_entrance",
  "foot": "du2YyW_foot",
  "in": "du2YyW_in",
  "inCarousel": "du2YyW_inCarousel",
  "intro": "du2YyW_intro",
  "isContain": "du2YyW_isContain",
  "isPhoto": "du2YyW_isPhoto",
  "media": "du2YyW_media",
  "mediaWrap": "du2YyW_mediaWrap",
  "price": "du2YyW_price",
  "priceRow": "du2YyW_priceRow",
  "text": "du2YyW_text",
});
